import { SolicitacoesService } from './solicitacoesService';
import { Documento } from '../types';

export class SincronizacaoDocumentosService {
  /**
   * Sincroniza um documento do pedido com a solicitação original
   */
  static async sincronizarDocumentoPedidoComSolicitacao(
    solicitacaoId: string,
    documento: Omit<Documento, 'id' | 'uploadedAt'>
  ): Promise<void> {
    try {
      if (!solicitacaoId) {
        console.warn('Solicitação ID não fornecido para sincronização');
        return;
      }

      // Adicionar o documento à solicitação original
      await SolicitacoesService.adicionarDocumento(solicitacaoId, documento);
    } catch (error) {
      console.error('Erro ao sincronizar documento com solicitação:', error);
      // Não lançar erro para não interromper o fluxo principal
    }
  }

  /**
   * Verifica se um documento já existe na solicitação
   */
  static async documentoExisteNaSolicitacao(
    solicitacaoId: string,
    storagePath: string
  ): Promise<boolean> {
    try {
      const solicitacao = await SolicitacoesService.buscarPorId(solicitacaoId);
      if (!solicitacao || !solicitacao.documentos) {
        return false;
      }

      return solicitacao.documentos.some(doc => doc.storagePath === storagePath);
    } catch (error) {
      console.error('Erro ao verificar documento na solicitação:', error);
      return false;
    }
  }
}
